import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { FlatList, View, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';

const AppList = _ref => {
  let {
    items,
    keyExtractor,
    renderItem,
    contentContainerStyle,
    separatorHeight = 1,
    isSeparatorVisible = false,
    style,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _style = styleGenerator(currentTheme);
  return /*#__PURE__*/React__default.createElement(FlatList, _extends({}, props, {
    ItemSeparatorComponent: props => {
      var _currentTheme$theme;
      return isSeparatorVisible ? /*#__PURE__*/React__default.createElement(View, {
        style: {
          height: separatorHeight,
          backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.lightGrey
        }
      }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    },
    style: [_style.container, style],
    contentContainerStyle: [_style.contentContainer, contentContainerStyle],
    data: items,
    keyExtractor: items => items[keyExtractor].toString(),
    renderItem: renderItem
  }));
};
const styleGenerator = props => {
  var _props$theme;
  return StyleSheet.create({
    container: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.backgroundColor
    },
    contentContainer: {
      justifyContent: "center",
      padding: 10
    }
  });
};
AppList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppList",
  "props": {
    "separatorHeight": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "required": false
    },
    "isSeparatorVisible": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppList as A };
